export default {
    authenticated: (state) => {
        return Boolean(state.token);
    },
    test_permissions: (state) => (requiredPermissions) => {
        if (!requiredPermissions) {
            return true;
        }
        const userPermissions = state.userdata.permissions || [];
        const splitted_perm = requiredPermissions.split(".");
        if (splitted_perm[1] === "any") splitted_perm[1] = "";
        const compiled_perm = splitted_perm.join(".");
        let filter_res = userPermissions.filter(
            (el) => el.indexOf(compiled_perm) === 0
        );

        return filter_res.length > 0;
    },
};
